module.exports = __webpack_public_path__ + "img/gb-eng.797c586f.svg";